import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

interface SettingResponse {
  showProductivityCard: boolean;
  exportPath: string;
}

@Injectable({
  providedIn: "root",
})
export class SettingsService {
  constructor(private http: HttpClient) {}

  public getProductivitySettings(): Observable<any> {
    return this.http.get<any>(environment.assetsDataPath + "settings.json").pipe(
      map((item) => {
        return this.getProductivityValue(item);
      })
    );
  }

  private getProductivityValue(response: SettingResponse): boolean {
    return response.showProductivityCard;
  }

  public getExportPathSettings(): Observable<any> {
    return this.http
      .get<any[]>(environment.assetsDataPath + "settings.json")
      .pipe(map((item) => item.map((res) => this.getExportPathValue(res))));
  }


  private getExportPathValue(response: SettingResponse): string {
    return response.exportPath;
  }
}
